import { handleActions } from 'redux-actions'

import { creditCardActions } from '../types'

const initialState = {
  id: null,
  cc_type: null,
}

export default handleActions(
  {
    [creditCardActions.CREDITCARD_SET]: (state, action) => {
      return ({
        ...state,
        cc_type: action.payload.cc_type,
        id: action.payload.id,
        // BOTS-48: the schedule token's info carries the specific payment the borrower link was
        // created for; surface it so Payment.getActivePayment can target that exact payment.
        payment_id: action.payload.payment_id,
      })
    },
    [creditCardActions.CREDITCARD_UPDATE]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
  initialState,
)
